import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-[--color-primary]">404</p>
        <h1 className="mt-2 text-3xl font-semibold text-slate-800">Page not found</h1>
        <p className="mt-2 text-slate-500">The page you're looking for doesn't exist.</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-blue-600 px-2 py-1 text-sm font-medium text-white hover:opacity-90"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
